import { Box, Button, Typography } from "@mui/material";

import useRssLinksSettings from "@app/analytics/hooks/settings/useRssLinksSettings";
import { CALENDAR_PROVIDERS_BY_ID } from "@app/common/constants/providers";
import ROUTES from "@app/common/routes";

import { Link } from "@rui/Link";
import Stack, { Row } from "@rui/Stack";

const SchedulingBanner = () => {
  const { rssCalendar } = useRssLinksSettings();

  if (!rssCalendar) return null;

  const providerConfig = CALENDAR_PROVIDERS_BY_ID[rssCalendar.provider];

  return (
    <Stack
      variant="apart"
      sx={{ bgcolor: "shades.ghost.300", borderRadius: "6px" }}
      padding={{ xxs: 1, mobile: 0.5 }}
      marginBottom={3}
      direction={{ xxs: "column", mobile: "row" }}
    >
      <Row variant="apart" spacing={1}>
        <Stack
          padding="2px"
          variant="center"
          borderRadius="2px"
          sx={{ backgroundColor: "#FFF" }}
        >
          <Box component="img" src={providerConfig.icon} height="22px" />
        </Stack>
        <Typography variant="bodySecondaryReg">
          Scheduling based on: {rssCalendar.summary} (
          {providerConfig.displayName})
        </Typography>
      </Row>
      <Row variant="right" spacing={0.5}>
        <Link to={ROUTES.USER_SETTINGS_INTEGRATIONS}>
          <Button sx={{ whiteSpace: "nowrap" }}>Change Calendar</Button>
        </Link>
        <Link to={ROUTES.USER_SETTINGS_SMART_SCHEDULER}>
          <Button sx={{ whiteSpace: "nowrap" }}>Scheduling Settings</Button>
        </Link>
      </Row>
    </Stack>
  );
};

export default SchedulingBanner;
